module.exports = __webpack_public_path__ + "img/cupWhite.ab3403f8.svg";